module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8491/img/blobsLeft.png"